let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fiOV9"), load("lPQcc"), load("WlGjZ")]).then(() => parcelRequire('gUdsz'));